import { CampaignReport } from "../../constants/action-constants/CampaignReportActionConstants";

export const getCampaignOverview = (id) => ({
  type: CampaignReport.CAMPAIGN_OVERVIEW,
  payload: { id },
});

export const generateMavinReport = (campaignId) => ({
  type: CampaignReport.GENERATE_MAVIN_REPORT,
  payload: { campaignId },
});

export const downloadExcelReport = (
  campaignId,
  campaignTitle,
  isMantaraySpecific
) => ({
  type: CampaignReport.DOWNLOAD_XLS_REPORT,
  payload: { campaignId, campaignTitle, isMantaraySpecific },
});

export const downloadCampaignPdfReport = (
  campaignId,
  isSentViaEmail,
  emailIds
) => ({
  type: CampaignReport.DOWNLOAD_CAMPAIGN_PDF_REPORT,
  payload: { campaignId, isSentViaEmail, emailIds },
});

export const resetCampaignPdfReport = () => ({
  type: CampaignReport.RESET_CAMPAIGN_PDF_REPORT,
});

export const generateCampaignExcelReport = (
  campaignId,
  isDemographicStatsInProgress
) => ({
  type: CampaignReport.GENERATE_CAMPAIGN_EXCEL_REPORT,
  payload: { campaignId, isDemographicStatsInProgress },
});

export const openDownloadCampaignReportForm = () => ({
  type: CampaignReport.OPEN_DOWNLOAD_CAMPAIGN_REPORT_MODAL,
});

export const closeDownloadCampaignReportForm = () => ({
  type: CampaignReport.CLOSE_DOWNLOAD_CAMPAIGN_REPORT_MODAL,
});
